import { LoadingButton } from '@mui/lab'
import { Box, Typography } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useUpdateKycMutation } from '~/app/store/services'
// import { Button, Checkbox, FormControlLabel } from '@mui/material'
import { BottomSheetContainer } from './MuiComponents'
// import { instructionData } from '~/utils/data'
// import Card from './card'
import LinearProgress from '@mui/material/LinearProgress'
import KycPermissions from './KycPermissions'
import { t } from '~/utils/narration'

export default function Instruction({ onContinue, id }: any) {
  const [updateKyc] = useUpdateKycMutation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const [loading, setLoading] = useState(false)
  const [loadingLocation, setLoadingLocation] = useState(false)

  const getLocation = async () => {
    if (loading) return
    setLoading(true)
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
      stream.getTracks().forEach((track) => track.stop())
    } catch (error) {
      console.log(error)
      enqueueSnackbar(
        t({
          en: 'Unable to access your camera. Please grant permission before continuing.',
          hi: 'कैमरा चालू नहीं हो पाया। कृपया आगे बढ़ने से पहले कैमरे की अनुमति दें।',
        }),
        {
          variant: 'error',
          anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
        }
      )
      setLoading(false)
    }
    try {
      setLoadingLocation(true)
      await navigator.permissions.query({ name: 'geolocation' })
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          console.log('get position ', {
            latitude: position?.coords?.latitude,
            longitude: position?.coords?.longitude,
          })

          await updateKyc({
            token,
            id,
            status: 'instruction',
            geo_coord: {
              latitude: position?.coords?.latitude,
              longitude: position?.coords?.longitude,
            },
          }).unwrap()
          onContinue()
        },
        (err) => {
          enqueueSnackbar(
            t({
              en: 'Unable to fetch your current location. Please allow location permission',
              hi: 'आपकी लोकेशन नहीं मिल पाई। कृपया लोकेशन की अनुमति दें।',
            }),
            { variant: 'error', anchorOrigin: { horizontal: 'center', vertical: 'bottom' } }
          )
          console.log(err)
          setLoadingLocation(false)
          setLoading(false)
        }
      )
    } catch (error) {
      console.error(error)
      setLoadingLocation(false)
      setLoading(false)
      enqueueSnackbar(
        t({
          en: 'Unable to fetch your current location. Please allow location permission',
          hi: 'आपकी लोकेशन नहीं मिल पाई। कृपया लोकेशन की अनुमति दें।',
        }),
        {
          variant: 'error',
          anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
        }
      )
    }
  }

  return (
    <>
      <Typography variant="h5" fontWeight="bold" sx={{ pb: 2, pt: 4 }} gutterBottom>
        {t({ en: 'Please allow these permissions', hi: 'कृपया ये अनुमतियाँ प्रदान करें' })}
      </Typography>
      <Typography variant="subtitle1" color="#66667a" gutterBottom sx={{ textAlign: 'left' }}>
        {t({
          en: 'To complete the KYC process, we need the following permissions. Please grant them when prompted. If you’ve already granted these permissions, you can simply continue.',
          hi: 'केवाईसी प्रक्रिया पूरी करने के लिए, हमें निम्नलिखित अनुमतियाँ चाहिए। संकेत मिलने पर कृपया इन्हें प्रदान करें। यदि आपने पहले ही ये अनुमतियाँ दे दी हैं, तो आप बस आगे बढ़ सकते हैं।',
        })}
      </Typography>
      <KycPermissions />

      {/* <Stack alignItems="stretch" flexDirection="row" flexWrap="wrap" justifyContent="center">
        {instructionData.map((data) => (
          <Card key={data.title} {...data} />
        ))}
      </Stack> */}

      <BottomSheetContainer maxWidth="sm">
        {loadingLocation ? (
          <>
            <Box sx={{}}>
              <Typography
                variant="h6"
                fontWeight={600}
                py={1}
                borderBottom="1px solid rgba(0,0,0,0.0)"
              >
                {t({ en: 'Fetching your current location...', hi: 'आपकी लोकेशन पता की जा रही है...' })}
              </Typography>
              <LinearProgress />
            </Box>
            <Box sx={{ px: 2, py: 4.5 }}>
              <img
                src="/images/location.gif"
                alt="location"
                style={{ width: '60px', height: 'auto' }}
              />
            </Box>
          </>
        ) : (
          <>
            <Box sx={{}}>
              <Typography
                variant="h6"
                fontWeight={600}
                py={1}
                borderBottom="2px solid rgba(0,0,0,0.06)"
              >
                {t({ en: 'Give required permissions', hi: 'आवश्यक अनुमतियाँ दें' })}
              </Typography>
            </Box>
            <Box sx={{ px: 2, py: 1.5 }}>
              <Typography
                variant="subtitle1"
                color="#222"
                gutterBottom
                sx={{ mb: 2, textAlign: 'start' }}
              >
                {t({
                  en: 'When prompted, tap ‘Allow’ and choose ‘Precise’ location for location permission.',
                  hi: 'संकेत मिलने पर, ‘Allow’ पर टैप करें और स्थान की अनुमति के लिए ‘Precise’ स्थान चुनें।',
                })}
              </Typography>
              <LoadingButton
                variant="contained"
                loading={loading}
                fullWidth
                onClick={getLocation}
                size="large"
                sx={{ py: 1.5 }}
              >
                {t({ en: 'Continue', hi: 'आगे बढ़ें' })}
              </LoadingButton>
            </Box>
          </>
        )}
      </BottomSheetContainer>

      {/* <Box flex={1} />
      <Container maxWidth="sm" sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}>
        <LoadingButton
          variant="contained"
          loading={loading}
          fullWidth
          onClick={getLocation}
          size="large"
          sx={{ my: 3, py: 1.5 }}
        >
          Proceed
        </LoadingButton>
      </Container> */}
    </>
  )
}
